// extracted by mini-css-extract-plugin
module.exports = {"keyStats":"style_keyStats___2fCS","head":"style_head__aaGj3","content":"style_content__Hd9f6","item":"style_item__bTgf7","halfItem":"style_halfItem__gQ2MZ"};